import React, { useEffect, useRef } from 'react'
import 'src/pages/Game/Game.scss'
import Container from "src/components/Container/Container"
import { useChat, useSessionContext, useTimerContext } from "src/hooks"
import { Form, Formik, FormikHelpers, FormikValues } from "formik"
import { getStyles } from "src/helpers"
import Heading from "src/components/Heading/Heading"
import Paragraph from "src/components/Paragraph/Paragraph"
import CompanyLogo from "src/components/CompanyLogo/CompanyLogo"
import { AppCompaniesChoices } from "src/types"
import Stepper from "src/components/Stepper/Stepper"
import Bubble from "src/components/Bubble/Bubble"
import Loader from "src/components/Loader/Loader"
import Timer from "src/components/Timer/Timer"
import TextInput from "src/components/TextInput/TextInput"

const Game = () => {
    const {
        messages,
        sendMessage,
        isPending,
        isCorrectAnswer
    } = useChat()
    const messageAreaRef = useRef<HTMLDivElement>(null)
    const { currentCompany } = useSessionContext()
    const { timerStatus } = useTimerContext()
    console.log('timerStatus', timerStatus)

    useEffect(() => {
        if (messageAreaRef.current) {
            messageAreaRef.current.scrollTop = messageAreaRef.current.scrollHeight
        }
    }, [messageAreaRef, messages])

    const handleSubmit = (values: FormikValues, formikHelpers: FormikHelpers<any>) => {
        sendMessage({ values: values })
        formikHelpers.resetForm()
    }

    const chatStyles = getStyles('chat', [currentCompany as string])

    if (!currentCompany) {
        return null
    }

    return (
        <Container
            containerOuterClassName={"game__container"}
        >
            <Formik
                onSubmit={handleSubmit}
                initialValues={{
                    message: ""
                }}
                enableReinitialize={true}
            >
                {({ values, handleSubmit }) => {
                    return (
                        <Form>
                            <div className={chatStyles}>
                                <header className={"chat-header"}>
                                    <div className={"chat-header__container"}>
                                        <div className={"chat-header__ai-logo"}>
                                            <img src="/misc/santa.png" alt=""/>
                                        </div>
                                        <div className={'chat-header__santa'}>
                                            <Heading size={3} className={"chat-header__inter"}>
                                                Дедушка Мороз
                                            </Heading>
                                            <Paragraph variant={3} className={"black-50"}>
                                                Департамент
                                                <br/>
                                                новогоднего настроения
                                            </Paragraph>
                                        </div>
                                    </div>
                                    <CompanyLogo name={AppCompaniesChoices[currentCompany]} mode={"chat"}/>
                                </header>
                                <div
                                    className={`chat__message-area`}
                                    ref={messageAreaRef}
                                >
                                    <Stepper className={"chat__stepper"}/>
                                    {messages.map((message) => {
                                        return (
                                            <Bubble {...message} key={message.time.toString()}/>
                                        )
                                    })}
                                    {
                                        isPending ?
                                            <Loader/>
                                            : null
                                    }
                                    {
                                        isCorrectAnswer
                                            ?
                                            <Timer/>
                                            : null
                                    }
                                </div>
                                <div
                                    className={"chat__input"}
                                >
                                    <TextInput
                                        disabled={timerStatus}
                                        onClick={() => {
                                            if (!isPending && values.message) {
                                                handleSubmit()
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </Container>
    )
}

export default Game